<script setup lang="ts">
import { RowInfo } from '@shared/ui/other'

import { useMainInfoPremium } from '../../model/main-info-premium.hook'

defineOptions({
  name: 'MainInfoPremium',
})

const { refValue } = useMainInfoPremium()
</script>

<template>
  <RowInfo
    title="Premium"
    :value="refValue"
  />
</template>
